import axios from 'axios';
const CREDIT_CARD_BE_PREFIX = '/apps/creditcard';

export default {
	getBonus() {
		return axios.get(CREDIT_CARD_BE_PREFIX + '/api/bonus/entry-discount');
	}
};
